import axiosReq from "../utils/axiosReq";
// import axios from 'axios';
// import { useUserStore } from '@/framework/store/user';
// import { downloadFile } from "./base_const.js"
/*
 *数据服务
 */
const baseApi =
    import.meta.env.VITE_APP_NODE_ENV == 'development' ? "/OpenApiPrefix/api" : '/api';

export const truckModelPropertyListHttpUrl = `${baseApi}/board/v1/mgmt/truck-model/get-truck-model-property` //车型码属性配置列表
export const vehicleModelListHttpUrl = `${baseApi}/board/v1/mgmt/truck-model/list` //车型码列表
export const newVehicleModelListHttpUrl = `${baseApi}/board/v1/mgmt/truck-model/dtip-list` //车型码列表新
export const truckManualListHttpUrl = `${baseApi}/board/v1/truck-manual/list` //手册列表


export function getVehicleModelDetailInfoHttpReq(id){
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/truck-model/${id}`,
        method: 'get',
    });
}

  /**
     * 保存车型码配置信息
     * @param param 车型码配置的基本信息
     * @returns {AxiosPromise<any>}
     */
 export function addOrEditTruckModelInfoHttpReq(data) {
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/truck-model/`,
        method: 'post',
        data
    });
}

/**
 * 查询车型码是否存在
 */
export function queryVehicleModelCodeExistHttpReq(code){
    return axiosReq({
        url: `${baseApi}/board/v1/mgmt/truck-model/get-by-code/${code}`,
        method: 'get',
    });
}
//删除车型码
export function deleteVehicleModelHttpReq(code) {
    return axiosReq({
      url: `${baseApi}/board/v1/mgmt/truck-model/del/${code}`,
      method: 'delete'
    })
  }

